export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-white py-10 sm:py-12" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-1 sm:col-span-2">
            <h2 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Curtis Waters AI
            </h2>
            <p className="text-sm sm:text-base text-gray-300 mb-4 sm:mb-6 max-w-md">
              AI Solutions Engineered to Scale Your Business Without the Overhead. Transform your operations with intelligent automation and real-time insights.
            </p>
            <nav aria-label="Social media links">
              <ul className="flex space-x-4">
                <li>
                  <a href="https://www.youtube.com/@CurtisWaters" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-red-400 transition-colors cursor-pointer touch-target" aria-label="Subscribe to Curtis Waters on YouTube">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-youtube-fill text-xl" aria-hidden="true"></i>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/in/curtiswaters/" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-red-400 transition-colors cursor-pointer touch-target" aria-label="Follow Curtis Waters on LinkedIn">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-linkedin-fill text-xl" aria-hidden="true"></i>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="https://x.com/curtiswaters" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-red-400 transition-colors cursor-pointer touch-target" aria-label="Follow Curtis Waters on X">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-twitter-x-line text-xl" aria-hidden="true"></i>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/curtiswatersnc" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-red-400 transition-colors cursor-pointer touch-target" aria-label="Follow Curtis Waters on Facebook">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-facebook-fill text-xl" aria-hidden="true"></i>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/curtiswatersnc/" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-red-400 transition-colors cursor-pointer touch-target" aria-label="Follow Curtis Waters on Instagram">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-instagram-line text-xl" aria-hidden="true"></i>
                    </div>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          
          <nav aria-label="Solutions links">
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Solutions</h3>
            <ul className="space-y-2">
              <li><a href="#solutions" className="text-sm sm:text-base text-gray-300 hover:text-red-400 transition-colors cursor-pointer touch-target inline-block py-1">Revenue Intelligence</a></li>
              <li><a href="#solutions" className="text-sm sm:text-base text-gray-300 hover:text-red-400 transition-colors cursor-pointer touch-target inline-block py-1">Customer Intelligence</a></li>
              <li><a href="#solutions" className="text-sm sm:text-base text-gray-300 hover:text-red-400 transition-colors cursor-pointer touch-target inline-block py-1">Marketing Automation</a></li>
              <li><a href="#solutions" className="text-sm sm:text-base text-gray-300 hover:text-red-400 transition-colors cursor-pointer touch-target inline-block py-1">Workflow Optimization</a></li>
            </ul>
          </nav>
          
          <nav aria-label="Other websites">
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Other Sites</h3>
            <ul className="space-y-2">
              <li><a href="https://CurtisWaters.com" target="_blank" rel="noopener noreferrer nofollow" className="text-sm sm:text-base text-gray-300 hover:text-red-400 transition-colors cursor-pointer touch-target inline-block py-1">Mergers &amp; Acquisitions</a></li>
              <li><a href="https://DominateWithBrand.com" target="_blank" rel="noopener noreferrer nofollow" className="text-sm sm:text-base text-gray-300 hover:text-red-400 transition-colors cursor-pointer touch-target inline-block py-1">Dominate With Brand AI</a></li>
              <li><a href="https://EntrepreneursReport.com" target="_blank" rel="noopener noreferrer nofollow" className="text-sm sm:text-base text-gray-300 hover:text-red-400 transition-colors cursor-pointer touch-target inline-block py-1">Entrepreneurs Report</a></li>
            </ul>
          </nav>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-gray-400 text-xs sm:text-sm text-center md:text-left">
            &copy; {currentYear} Curtis Waters AI. All rights reserved.
          </p>
          <nav aria-label="Legal links" className="flex flex-wrap items-center justify-center gap-4">
            <a href="/privacy-policy" className="text-gray-400 hover:text-red-400 text-xs sm:text-sm transition-colors cursor-pointer touch-target">
              Privacy Policy
            </a>
            <a href="/terms-and-conditions" className="text-gray-400 hover:text-red-400 text-xs sm:text-sm transition-colors cursor-pointer touch-target">
              Terms &amp; Conditions
            </a>
            <a href="/cookie-policy" className="text-gray-400 hover:text-red-400 text-xs sm:text-sm transition-colors cursor-pointer touch-target">
              Cookie Policy
            </a>
            <a href="/accessibility" className="text-gray-400 hover:text-red-400 text-xs sm:text-sm transition-colors cursor-pointer touch-target">
              Accessibility
            </a>
            <a href="/do-not-sell" className="text-gray-400 hover:text-red-400 text-xs sm:text-sm transition-colors cursor-pointer touch-target">
              Do Not Sell My Personal Information
            </a>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-400 text-xs sm:text-sm transition-colors cursor-pointer touch-target">
              Powered by Readdy
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}